export class ServicoRequest {
    descricao: string;
    codigo?: string;
    isAtivo: boolean = true;
    preco: number = 0;
    idUnidadeMedida?: number;
    idTipoItemSped?: number;
    codigoTributacaoNacionalServico?: string;
    descricaoTributacaoNacionalServico?: string;
    codigoTributacaoNacionalServicoLc116?: string;
    codigoMunicipalComplementar?: string;
    nbs?: string;
    descricaoComplementar?: string;
    observacao?: string;
    informouCodigoTributacaoNacionalServicoManualmente?: boolean;
}
